import React, { useState, useMemo } from 'react';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { getObjectIcon } from '../../constants/migrationConstants';
import getTooltip from '../shared/MigrationToolTip';
import useStyles from './styles/VisibilityCard.styles';
import { UI_LABELS } from '../../constants/stringConstants';

const parseTooltipHtml = (html) => {
  if (!html) return null;
  const parts = html.split(/(<b>|<\/b>|<br\s*\/?>)/gi);
  let bold = false;
  return parts.map((part, i) => {
    const lower = part.toLowerCase();
    if (lower === '<b>') { bold = true; return null; }
    if (lower === '</b>') { bold = false; return null; }
    if (/^<br\s*\/?>$/i.test(part)) return <br key={i} />;
    if (!part) return null;
    // eslint-disable-next-line react/no-array-index-key
    return bold ? <b key={i}>{part}</b> : <span key={i}>{part}</span>;
  });
};

function VisibilityCard({ item, sourceType }) {
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);
  const tooltip = getTooltip(item.objectType, sourceType);

  const parsedTooltip = useMemo(() => parseTooltipHtml(tooltip), [tooltip]);

  return (
    <div className={`${classes.card} ${isExpanded ? classes.cardExpanded : ''}`}>
      <div className={classes.header}>
        <div className={classes.iconWrapper}>{getObjectIcon(item.objectType)}</div>
        <div className={classes.titleContainer}>
          <Typography variant="h6" className={classes.title}>
            {item.objectType.replace(/([A-Z])/g, ' $1').trim()}
          </Typography>
        </div>
        <div className={classes.countBadge}>
          <Typography className={classes.count}>{item.count.toLocaleString()}</Typography>
        </div>
      </div>

      <Typography
        variant="body2"
        className={`${classes.description} ${!isExpanded ? classes.descriptionCollapsed : ''}`}
      >
        {parsedTooltip}
      </Typography>

      {tooltip.length > 120 && (
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className={classes.toggleButton}
        >
          {isExpanded ? UI_LABELS.SHOW_LESS : UI_LABELS.SHOW_MORE}
          <span className={`${classes.chevron} ${isExpanded ? classes.chevronOpen : ''}`}>▼</span>
        </button>
      )}
    </div>
  );
}

VisibilityCard.propTypes = {
  item: PropTypes.shape({
    objectType: PropTypes.string.isRequired,
    count: PropTypes.number.isRequired,
  }).isRequired,
  sourceType: PropTypes.string,
};

VisibilityCard.defaultProps = {
  sourceType: null,
};

export default VisibilityCard;
